import apiClient from "./apiClient";
import {
  FileDetailsRequest,
  FileDetailsResponse,
} from "./Models/DocumentsModel";
import { AxiosResponse } from "axios";

export const getFileDetails = async (
  securityToken: string,
  language: string,
  idObject: number,
  idDoc: number,
  fileNameUrl: string,
  MD5: string,
  fileContent: string
): Promise<FileDetailsResponse> => {
  const requestData: FileDetailsRequest = {
    SecurityToken: securityToken,
    Language: language,
    IdObject: idObject,
    IdDoc: idDoc,
    FileName: fileNameUrl,
    MD5: MD5,
    FileContent: fileContent,
  };

  try {
    const response: AxiosResponse<FileDetailsResponse> = await apiClient({
      method: "post",
      url: "/FileDetails/GetFileDetails",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("CMSGetFilterResult Error:", error);
    throw error;
  }
};
